import React, { useState, useEffect } from 'react';
import { MedievalIntro } from './components/MedievalIntro';
import { HomePage } from './components/HomePage';
import { GameInterface } from './components/GameInterface';
import { CryptoLibrary } from './components/library/CryptoLibrary';
import { HallOfChampions } from './components/champions/HallOfChampions';
import { TrainingGrounds } from './components/training/TrainingGrounds';
import { InventoryPage } from './components/InventoryPage';
import { ArcadiaTerminalPage } from './components/ArcadiaTerminalPage';
import { PvPCombat } from './components/combat/PvPCombat';
import { UserRegistration } from './components/auth/UserRegistration';
import { useLeaderboardStore } from './store/leaderboardStore';
import { useUser } from './hooks/useUser';
import type { User } from './types/user';

type View = 'intro' | 'registration' | 'home' | 'arcade' | 'library' | 'champions' | 'training' | 'inventory' | 'terminal' | 'battle';

export default function App() {
  const [currentView, setCurrentView] = useState<View>(() => {
    const storedUser = localStorage.getItem('kingdom-user');
    return storedUser ? 'home' : 'intro';
  });
  
  const [user, setUser, clearUser] = useUser();
  const addUserToLeaderboard = useLeaderboardStore(state => state.addUser);

  const handleIntroComplete = () => {
    setCurrentView('registration');
  };

  const handleRegister = (username: string, walletAddress: string) => {
    const newUser = {
      username,
      walletAddress,
      points: 30000
    };
    setUser(newUser);
    addUserToLeaderboard(newUser);
    setCurrentView('home');
  };

  const handleNavigate = (path: string) => {
    const view = path.slice(1) as View;
    if (!user) {
      setCurrentView('registration');
    } else {
      setCurrentView(view);
    }
  };

  const handleLogout = () => {
    clearUser();
    setCurrentView('intro');
  };

  return (
    <>
      {currentView === 'intro' && (
        <MedievalIntro onComplete={handleIntroComplete} />
      )}
      {currentView === 'registration' && (
        <UserRegistration
          onRegister={handleRegister}
          onCancel={() => setCurrentView('intro')}
        />
      )}
      {currentView === 'home' && (
        <HomePage 
          onNavigate={handleNavigate} 
          user={user}
          onLogout={handleLogout}
        />
      )}
      {currentView === 'arcade' && (
        <GameInterface onBack={() => setCurrentView('home')} user={user} />
      )}
      {currentView === 'library' && (
        <CryptoLibrary onBack={() => setCurrentView('home')} />
      )}
      {currentView === 'champions' && (
        <HallOfChampions onBack={() => setCurrentView('home')} />
      )}
      {currentView === 'training' && (
        <TrainingGrounds onBack={() => setCurrentView('home')} user={user} />
      )}
      {currentView === 'inventory' && (
        <InventoryPage onBack={() => setCurrentView('home')} user={user} />
      )}
      {currentView === 'terminal' && (
        <ArcadiaTerminalPage onBack={() => setCurrentView('home')} />
      )}
      {currentView === 'battle' && (
        <div className="min-h-screen bg-amber-900 text-amber-100 p-8 bg-[url('https://images.unsplash.com/photo-1578662996442-48f60103fc96?auto=format&fit=crop&q=80')] bg-cover bg-center bg-blend-overlay">
          <div className="max-w-6xl mx-auto">
            <PvPCombat user={user} onBack={() => setCurrentView('home')} />
          </div>
        </div>
      )}
    </>
  );
}